import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Widget } from '@ispm/widgets/decorator/widget.decorator';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { IspmHttpClient } from '@ispm/core/services/ispm-http-client';
import { Subject } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { DynamicApiService } from '../../../../app/export/services/dynamic-api.service';
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'gen-clone-report-template',
  templateUrl: './clone-report-template.component.html',
  styleUrls: ['./clone-report-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('clone-report-template')
export class CloneReportTemplateComponent implements OnInit, OnDestroy, IWidgetItem<any> {

  public _formConfig: Array<any>;
  public widgetFormInstance: FormGroup;
  private _widgetFormInstanceSubmitted: boolean;

  public widgetPayload: any;
  private destroyed$: Subject<any> = new Subject();
  public inputConfig = [];
  widgetUpdateValueCallback: (value) => void;
  widgetSubmitStatusValueCallback: (value: boolean) => void;
  public listenToDataChange = true;
  public formData: any;
  private submitUri = 'reporttemplate/clone';
  public fileName: any;
  public title: string;
  private reportType: string;
  constructor(private _ispmHttpClient: IspmHttpClient,
              private _notificationMessageService: NotificationMessageService,
              private _changeDetector: ChangeDetectorRef,
              private _dynamicApiService: DynamicApiService) {
  }

  ngOnInit() {
  }

  set widgetData(widgetData: any) {
    this.formData = widgetData;
    if (this.formData) {
      this._changeDetector.markForCheck();
    }
  }

  set widgetConfig(widgetConfig) {

    this.widgetPayload = widgetConfig.widgetPayload;
    this._formConfig = this.widgetPayload.formConfig;
  }

  public get widgetFormInstanceSubmitted() {
    return this._widgetFormInstanceSubmitted;
  }

  public formUpdate(form) {
    this.title = form.title;
    this.reportType = form.type;
    this._changeDetector.markForCheck();
  }

  public set widgetFormInstanceSubmitted(widgetFormInstanceSubmitted: boolean) {
    this._widgetFormInstanceSubmitted = widgetFormInstanceSubmitted;
    this._changeDetector.markForCheck();
  }

  public cloneReportTemplate() {
      const orgId = JSON.parse(localStorage.getItem('user')).role == 'OrganizationAdministrator' ? JSON.parse(localStorage.getItem('user')).originalOrganization : JSON.parse(sessionStorage.getItem('Orgnization')).id;
      const body = {
        templateId: this.formData.templateId,
        title: this.title,
        type: this.reportType,
        orgId : orgId,
        user : JSON.parse(localStorage.getItem('user')).username
      };

      this._ispmHttpClient.post(this.submitUri, body)
        .pipe(takeUntil(this.destroyed$))
        .subscribe(
        result => {
          this._dynamicApiService.setReloadWorklistStatus(true);
          this._notificationMessageService.success('Template cloned successfully');
          this.widgetSubmitStatusValueCallback.apply(this, [false]);
        },
        error => {
          this.widgetSubmitStatusValueCallback.apply(this, [false]);
          this._notificationMessageService.error('Failed to clone template' + this.getErrorMessage(error.message));
        }
      );
    this._changeDetector.markForCheck();
  }

  private getErrorMessage(msg: string) {
    const msgs = msg.split(':');
    return msgs[msgs.length - 1];
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
    this._changeDetector.detach();
  }
}


